'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var styled = require('@emotion/styled');
var coreRenderer = require('@tempi/core-renderer');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const ProductPrice = ({
  supplierRetailPrice,
  latestPrice,
  textColor,
  align = "start"
}) => {
  const formattedRetailPrice = coreRenderer.formatCurrencyVND(supplierRetailPrice);
  const formattedLatestPrice = coreRenderer.formatCurrencyVND(latestPrice);
  const renderedLatestPrice = /* @__PURE__ */ jsxRuntime.jsx(StyledLatestPrice, {
    color: textColor,
    children: formattedLatestPrice
  });
  const renderedRetailPrice = /* @__PURE__ */ jsxRuntime.jsx(StyledRetailPrice, {
    children: formattedRetailPrice
  });
  return /* @__PURE__ */ jsxRuntime.jsxs(ProductPriceWrapper, {
    align,
    children: [
      renderedLatestPrice,
      /* @__PURE__ */ jsxRuntime.jsx(StyledDiscount, {
        children: supplierRetailPrice && supplierRetailPrice > latestPrice && renderedRetailPrice
      })
    ]
  });
};
const ProductPriceWrapper = styled__default["default"].div(
  ({ align }) => `
  display: flex;
  flex-direction: column;
  align-items: ${align};
`
);
const StyledLatestPrice = styled__default["default"].div(
  ({ color }) => `
  color: ${color || "rgb(235, 31, 58)"};
  font-weight: 700;
  text-decoration: unset;
  font-size: 15px;
  line-height: 24px;
`
);
const StyledRetailPrice = styled__default["default"].div`
  text-decoration: line-through;
  color: rgb(130, 134, 158);
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
`;
const StyledDiscount = styled__default["default"].div`
  display: flex;
  height: 1rem;
`;

exports.ProductPrice = ProductPrice;
